import React, { useState } from 'react';

import {
  Alert,
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

import Spinner from '~/components/Common/Spinner';

import { useDownloadLeLiveRegistrations } from '~/hooks/apis/occasions/useDownloadLeLiveRegistrations';

import { LeLiveExportFormat } from '~/services/OccasionsService';

export default function LeLiveContainer() {
  const [format, setFormat] = useState<LeLiveExportFormat | null>(null);
  const { mutate: download, isPending, error } = useDownloadLeLiveRegistrations();

  return (
    <Container maxWidth="xl" sx={{ width: '90%' }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Reports
        </Typography>

        <Box sx={{ mt: 2 }}>
          <FormControl required>
            <FormLabel>Format</FormLabel>
            <RadioGroup row value={format ?? ''} onChange={(e) => setFormat(e.target.value as LeLiveExportFormat)}>
              <FormControlLabel value="csv" control={<Radio />} label="CSV" />
              <FormControlLabel value="xlsx" control={<Radio />} label="XLSX" />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={{ mt: 3 }}>
          {isPending ? (
            <Spinner size={35} />
          ) : (
            <Button variant="contained" disabled={!format} onClick={() => format && download(format)}>
              Download Report
            </Button>
          )}
        </Box>

        {error && (
          <Box sx={{ mt: 2 }}>
            <Alert severity="error">{error.message}</Alert>
          </Box>
        )}
      </Box>
    </Container>
  );
}
